import Artwork from './components/Artwork'
import { useEffect, useState } from 'react'
import { getRandomRules } from './artwork/lib/rules'
import { useInterval } from 'usehooks-ts'
import { Rule } from './artwork/types'
import { changeResolution, settings } from './artwork/settings'
import { VERSION } from './artwork/const'

const MOD_INTERVAL = 200

console.log(`Anni (sync) - v${VERSION}`)

const RESOLUTION_OPTIONS = [1, 2, 3, 4, 5, 6]

function getInitialResolution(): number {
  const hash = window.location.hash.slice(1)
  const hashNum = parseInt(hash)
  if (RESOLUTION_OPTIONS.includes(hashNum)) return hashNum

  try {
    const stored = JSON.parse(localStorage.getItem('anni.sync') || '{}')
    const storedRes = parseInt(stored.resolution)
    if (RESOLUTION_OPTIONS.includes(storedRes)) return storedRes
  } catch {}

  return 1
}

export default function App() {
  const [rules, setRules] = useState<Rule[] | undefined>()
  const [seed, setSeed] = useState<number | undefined>(undefined)
  const [resolution, setResolution] = useState<number>(getInitialResolution)
  const [modalVisible, setModalVisible] = useState(true)
  const [modalMounted, setModalMounted] = useState(true)

  useEffect(() => {
    const fadeTimer = setTimeout(() => setModalVisible(false), 10000)
    const unmountTimer = setTimeout(() => setModalMounted(false), 11000)
    return () => {
      clearTimeout(fadeTimer)
      clearTimeout(unmountTimer)
    }
  }, [])

  const [displayThreshold, setDisplayThreshold] = useState(0)
  useInterval(() => {
    const now = +new Date() + settings.timeOffsetCorrection
    const now100ms = (now / 100) << 0
    if (settings.showStatistics) setDisplayThreshold(now100ms)
    if (now100ms % MOD_INTERVAL === 0) {
      console.log('new seed', now100ms)
      setSeed(now100ms)
    }
  }, 50)

  useEffect(() => {
    if (!seed) return
    console.log('new seed, new rules')
    setRules(getRandomRules(seed))
  }, [seed])

  return (
    <div className='container' style={{ cursor: modalMounted ? 'auto' : 'none' }}>
      <div className='artwork-container'>
        {rules && seed && <Artwork rules={rules} seed={seed} resolution={resolution} />}
      </div>
      {modalMounted && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: modalVisible ? 1 : 0,
            transition: 'opacity 1s ease-out',
            pointerEvents: modalVisible ? 'auto' : 'none',
            zIndex: 100
          }}
        >
          <div
            style={{
              background: 'rgba(0,0,0,0.8)',
              borderRadius: '8px',
              padding: '24px',
              display: 'flex',
              gap: '12px'
            }}
          >
            {RESOLUTION_OPTIONS.map(n => (
              <button
                key={n}
                onClick={() => { changeResolution(n); window.location.hash = String(n); setResolution(n); setModalVisible(false); setTimeout(() => setModalMounted(false), 1000) }}
                style={{
                  width: '48px',
                  height: '48px',
                  fontSize: '20px',
                  background: resolution === n ? 'white' : 'transparent',
                  color: resolution === n ? 'black' : 'white',
                  border: '2px solid white',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                {n}
              </button>
            ))}
          </div>
        </div>
      )}
      {settings.showStatistics && (
        <div
          style={{
            position: 'fixed',
            top: '0',
            right: '0',
            padding: '3px',
            fontSize: '3vw',
            boxSizing: 'border-box',
            fontFamily: 'monospace',
            backgroundColor:
              displayThreshold % 20 === 0 ? 'green' : 'rgba(0,0,0,0.5)',
            color: 'white'
          }}
        >
          {settings.timeOffsetCorrection} |{' '}
          {displayThreshold.toString().substring(6, 9)}
        </div>
      )}
    </div>
  )
}
